module.exports = "/deep/ app-header, /deep/ .stepper-wrapper {\n  display: none;\n}\n"